import { useViewContext } from "@folksam/ui/providers/ViewContext";
import React from "react";

import { Flex, Text } from "../../cores";

export interface ITableButton {
  iconRight:
    | ((passedProps: React.SVGProps<SVGSVGElement>) => JSX.Element)
    | null;
  index: number;
  text: string;
  onClick(): void;
}

const TableButton = React.forwardRef<HTMLDivElement, ITableButton>(
  ({ iconRight: IconRight, index, text, ...props }, ref) => {
    const { isMobile } = useViewContext();
    return (
      <Flex
        as="button"
        ref={ref}
        sx={{
          all: "unset",
          ":hover": {
            color: "primaryScale.4",
          },
          color: "primaryScale.6",
          height: "100%",
          boxSizing: "border-box",
          padding: "sm",
          width: "full",
          minHeight: "24px",
          marginLeft: index === 0 ? (isMobile ? "28px" : "36px") : 0,
          justifyContent: index === 0 ? "flex-start" : "center",
          alignItems: "center",
          cursor: "pointer",
          whiteSpace: "break-spaces",
          "&:focus-visible": {
            outline: "1px solid black",
          },
        }}
        {...props}
        id={index}
      >
        <Text
          sx={{
            textAlign: index === 0 ? "left" : "center",
            fontWeight: "600 !important",
          }}
        >
          {text}
        </Text>
        {IconRight && <IconRight />}
      </Flex>
    );
  }
);
export default TableButton;
